export default __webpack_public_path__ + "static/media/keystone.ac6d0b09.png";